module.exports = __webpack_public_path__ + "open-sans-v17-latin-300.woff?a7622f60c56ddd5301549a786b54e6e6";